import { useNavigate } from 'react-router-dom';

import { ContentNugget } from '@backrs_ui/common-ui';

import { handlePanelNuggetClick } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { NuggetSection } from '@backrs_ui/grow-ui/src/components/ResourceWrapper/NuggetSection';

import { useAgentContext } from './OpportunitiesSection.agentContext';

type OpportunitiesSectionProps = Readonly<{
  opportunities: ContentNugget[];
  isLoading: boolean;
}>;

export const OpportunitiesSection = ({ opportunities, isLoading }: OpportunitiesSectionProps) => {
  useAgentContext(opportunities);
  const navigate = useNavigate();

  const handleNuggetClick = (nugget: ContentNugget) => {
    handlePanelNuggetClick(nugget, navigate);
  };

  return (
    <NuggetSection nuggets={opportunities} onNuggetClick={handleNuggetClick} loading={isLoading} />
  );
};
